import React from 'react'

const Sensor = () => {
  return (
    <div>
         <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Process Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>Sensor and Actuator</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/sensor.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Sensor and Actuator:</h2>
                        <p className="mbot25">
                        We provide a wide range of sensors and actuators that detect environmental
                         changes and perform necessary actions. Our products ensure precise monitoring
                          and control, vital for maintaining efficient and safe operations
                        </p>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Sensor
